import React, { useEffect, useState } from "react";
import Navbar from "../component/NavBar";
import { useNavigate, Link } from "react-router-dom";
import Footer from "../component/Footer";
import { GetAllCartItems, DeleteCartItem } from "../Api/services/CartServices";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../component/common/Loader";
import { useDispatch } from "react-redux";
import { removeFromCart } from "../slices/cart.slice";

const Cart = () => {
    const dispatch = useDispatch();
    const [cartItems, setCartItems] = useState([]);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const fetchCartItems = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem("token");
            if (!token) {
                toast.error("Please login to view cart");
                navigate("/login");
                return;
            }
            const response = await GetAllCartItems(token);
            if (response.status === 200) {
                setCartItems(response.data.cartItems);
            }
        } catch (error) {
            console.error("Error fetching cart items:", error);
            toast.error(error.response?.data?.message || "Failed to fetch cart items");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCartItems();
        window.scrollTo(0, 0);
    }, []);

    const DeleteCart = async (_id) => {
        try {
            const token = localStorage.getItem("token");
            if (!token) {
                toast.error("Please login to remove items");
                return;
            }
            const response = await DeleteCartItem(token, _id);
            if (response.status === 200) {
                setCartItems(prevItems => prevItems.filter(item => item._id !== _id));
                dispatch(removeFromCart());
                toast.success("Item removed from cart");
            }
        } catch (error) {
            console.error("Error deleting cart item:", error);
            toast.error(error.response?.data?.message || "Failed to remove item");
        }
    };


    return (
        <>
            <Navbar />
            {loading ? <Loader /> : (
                <>
                    <Toaster position="top-right" />
                    <div className="max-w-7xl mx-auto p-2 sm:p-6 bg-white min-h-screen">
                        <h1 className="text-2xl sm:text-4xl font-bold mb-4 sm:mb-8 text-center">Shopping Cart</h1>
                        <div className="border-t border-gray-200">
                            {cartItems.length === 0 ? (
                                <div className="text-center py-12">
                                    <p className="text-2xl text-gray-600 mb-4">Your cart is empty</p>
                                    <Link to="/shop" className="inline-block px-6 py-3 bg-red-500 text-white rounded-md hover:bg-red-600 transition-colors">
                                        Continue Shopping
                                    </Link>
                                </div>
                            ) : (
                                <>
                                    {cartItems?.map((item) => (
                                        <div key={item._id} className="flex flex-row items-center py-4 border-b border-gray-200">
                                            <Link to={`/product/${item?.productId?._id}`}>
                                                <img
                                                    src={item?.productId?.images[0]}
                                                    alt={item.brand}
                                                    className="w-32 h-40 object-cover cursor-pointer rounded-md"
                                                />
                                            </Link>
                                            <div className="ml-4 sm:ml-8 flex-1">
                                                <h2 className="text-xl font-medium mb-2">{item?.title}</h2>
                                                <div className="flex justify-between items-start">
                                                    <div className="grid grid-cols-1 gap-1 text-base text-gray-600">
                                                        <p>Size: <span className="font-sm sm:font-medium">{item?.size}</span></p>
                                                        <p>Color: <span className="font-sm sm:font-medium">{item?.productId?.color}</span></p>
                                                        <p>Material: <span className=" font-sm sm:font-medium">{item?.productId?.material}</span></p>
                                                    </div>

                                                </div>

                                                <button
                                                    onClick={() => DeleteCart(item._id)}
                                                    className="mt-4 text-sm text-red-500 hover:text-red-700 transition-colors">
                                                    Remove
                                                </button>
                                            </div>

                                            <div className="flex flex-col items-end w-auto mt-0 space-y-4">
                                                <div className="flex items-center border border-gray-200 rounded-md">
                                                    <span className="px-4 py-2 border-x border-gray-200">{item?.quantity}</span>
                                                </div>
                                                <p className="text-md font-medium">Rs. {item?.productId?.discountedPrice * item?.quantity}</p>
                                            </div>
                                        </div>
                                    ))}


                                    {/* Subtotal and Checkout */}
                                    <div className="flex flex-row justify-between items-center mt-6 sm:mt-8 py-4 sm:py-6 border-t border-gray-200">
                                        <div className="mb-4 sm:mb-0">
                                            <p className="text-gray-600">Subtotal</p>
                                            <p className="text-sm sm:text-xl font-medium">
                                                Rs. {cartItems.reduce((total, item) => total + item?.productId?.discountedPrice * item.quantity, 0).toLocaleString("en-IN")}.00
                                            </p>
                                        </div>
                                        <button
                                            onClick={() => navigate("/checkout")}
                                            className="w-auto px-2 sm:px-4 py-3 sm:py-4 bg-red-500 text-white rounded-md shadow-md hover:bg-red-600 transition-colors text-sm sm:text-base font-medium">
                                            Proceed to Checkout
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    <Footer />
                </>
            )}
        </>
    );
};

export default Cart;
